import { render, staticRenderFns } from "./vue2-countdown.vue?vue&type=template&id=06ae6ed9&"
import script from "./vue2-countdown.vue?vue&type=script&lang=js&"
export * from "./vue2-countdown.vue?vue&type=script&lang=js&"
import style0 from "./vue2-countdown.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports